// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderPatient,
    ProviderPatientSortType,
    ProviderPatientStatement,
    SupportCreatePatientPayload,
    SupportDebug,
    SupportInboxPatientSubmissionResponse,
    SupportPatient,
    SupportPatientSortType,
    SupportReplacePatientPayload,
    SupportUpdatePatientPayload,
    TemporaryDocumentUrl,
    SupportCreatePatientPayloadToJSON,
    SupportReplacePatientPayloadToJSON,
    SupportUpdatePatientPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderPatientFromJSON,
    ProviderPatientStatementFromJSON,
    SupportDebugFromJSON,
    SupportInboxPatientSubmissionResponseFromJSON,
    SupportPatientFromJSON,
    TemporaryDocumentUrlFromJSON,
} from '../models';

export interface CreateSupportPatientRequest {
    supportCreatePatientPayload: SupportCreatePatientPayload;
}

export interface DisableSupportPatientRequest {
    id: string;
}

export interface ExecuteSupportPatientInboxSubmissionRequest {
    pid: string;
    id: string;
}

export interface GetProviderPatientRequest {
    id: string;
}

export interface GetProviderPatientStatementRequest {
    id: string;
}

export interface GetSupportPatientRequest {
    id: string;
}

export interface GetSupportPatientInboxSubmissionRequest {
    pid: string;
    id: string;
}

export interface ListProviderPatientsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderPatientsOrderEnum>;
    filterCreated?: Array<string>;
    filterExternalId?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterNickname?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterDob?: Array<string>;
    filterDod?: Array<string>;
    filterSex?: Array<string>;
    filterPhone?: Array<string>;
    filterEmail?: Array<string>;
    sort?: Array<ProviderPatientSortType>;
}

export interface ListSupportPatientsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportPatientsOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterTag?: Array<string>;
    filterActive?: string;
    filterExternalId?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterNickname?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterDob?: Array<string>;
    filterDod?: Array<string>;
    filterSex?: Array<string>;
    filterPhone?: Array<string>;
    filterEmail?: Array<string>;
    sort?: Array<SupportPatientSortType>;
}

export interface PatchSupportPatientRequest {
    id: string;
    supportUpdatePatientPayload: SupportUpdatePatientPayload;
}

export interface PostSupportPatientDebugRoyalCollectionsRequest {
    id: string;
}

export interface PostSupportPatientInboxSubmissionRequest {
    id: string;
}

export interface PostSupportPatientPreviewRoyalCollectionsRequest {
    id: string;
}

export interface ReplaceSupportPatientRequest {
    supportReplacePatientPayload: SupportReplacePatientPayload;
}

export interface UpdateSupportPatientRequest {
    id: string;
    supportUpdatePatientPayload: SupportUpdatePatientPayload;
}

/**
 * no description
 */
export class PatientApi extends runtime.BaseAPI {

    /**
     * Create a patient
     * Create a patient
     */
    async createSupportPatientRaw(requestParameters: CreateSupportPatientRequest): Promise<runtime.ApiResponse<SupportPatient>> {
        if (requestParameters['supportCreatePatientPayload'] === null || requestParameters['supportCreatePatientPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreatePatientPayload','Required parameter requestParameters.supportCreatePatientPayload was null or undefined when calling createSupportPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:patient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreatePatientPayloadToJSON(requestParameters['supportCreatePatientPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPatientFromJSON(jsonValue));
    }

    /**
     * Create a patient
     * Create a patient
     */
    async createSupportPatient(requestParameters: CreateSupportPatientRequest): Promise<SupportPatient> {
        const response = await this.createSupportPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a patient
     * Disable a patient
     */
    async disableSupportPatientRaw(requestParameters: DisableSupportPatientRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:patient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a patient
     * Disable a patient
     */
    async disableSupportPatient(requestParameters: DisableSupportPatientRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Execute Inbox Patient Submission
     * Execute Inbox Patient Submission
     */
    async executeSupportPatientInboxSubmissionRaw(requestParameters: ExecuteSupportPatientInboxSubmissionRequest): Promise<runtime.ApiResponse<SupportInboxPatientSubmissionResponse>> {
        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling executeSupportPatientInboxSubmission.');
        }

        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling executeSupportPatientInboxSubmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/{pid}/inbox_submission/{id}`.replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportInboxPatientSubmissionResponseFromJSON(jsonValue));
    }

    /**
     * Execute Inbox Patient Submission
     * Execute Inbox Patient Submission
     */
    async executeSupportPatientInboxSubmission(requestParameters: ExecuteSupportPatientInboxSubmissionRequest): Promise<SupportInboxPatientSubmissionResponse> {
        const response = await this.executeSupportPatientInboxSubmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a patient
     * Get a patient
     */
    async getProviderPatientRaw(requestParameters: GetProviderPatientRequest): Promise<runtime.ApiResponse<ProviderPatient>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/patient/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPatientFromJSON(jsonValue));
    }

    /**
     * Gets a patient
     * Get a patient
     */
    async getProviderPatient(requestParameters: GetProviderPatientRequest): Promise<ProviderPatient> {
        const response = await this.getProviderPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets patient statement (subject to change)
     * Get patient statement (subject to change)
     */
    async getProviderPatientStatementRaw(requestParameters: GetProviderPatientStatementRequest): Promise<runtime.ApiResponse<ProviderPatientStatement>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderPatientStatement.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/patient/{id}/statement`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPatientStatementFromJSON(jsonValue));
    }

    /**
     * Gets patient statement (subject to change)
     * Get patient statement (subject to change)
     */
    async getProviderPatientStatement(requestParameters: GetProviderPatientStatementRequest): Promise<ProviderPatientStatement> {
        const response = await this.getProviderPatientStatementRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a patient
     * Get a patient
     */
    async getSupportPatientRaw(requestParameters: GetSupportPatientRequest): Promise<runtime.ApiResponse<SupportPatient>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:patient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPatientFromJSON(jsonValue));
    }

    /**
     * Gets a patient
     * Get a patient
     */
    async getSupportPatient(requestParameters: GetSupportPatientRequest): Promise<SupportPatient> {
        const response = await this.getSupportPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get Inbox Patient Submission
     * Get Inbox Patient Submission
     */
    async getSupportPatientInboxSubmissionRaw(requestParameters: GetSupportPatientInboxSubmissionRequest): Promise<runtime.ApiResponse<SupportInboxPatientSubmissionResponse>> {
        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling getSupportPatientInboxSubmission.');
        }

        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportPatientInboxSubmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/{pid}/inbox_submission/{id}`.replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportInboxPatientSubmissionResponseFromJSON(jsonValue));
    }

    /**
     * Get Inbox Patient Submission
     * Get Inbox Patient Submission
     */
    async getSupportPatientInboxSubmission(requestParameters: GetSupportPatientInboxSubmissionRequest): Promise<SupportInboxPatientSubmissionResponse> {
        const response = await this.getSupportPatientInboxSubmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of patients
     * Get a list of patients
     */
    async listProviderPatientsRaw(requestParameters: ListProviderPatientsRequest): Promise<runtime.ApiResponse<Array<ProviderPatient>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterNickname) {
            queryParameters['filterNickname'] = requestParameters.filterNickname;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterDob) {
            queryParameters['filterDob'] = requestParameters.filterDob;
        }

        if (requestParameters.filterDod) {
            queryParameters['filterDod'] = requestParameters.filterDod;
        }

        if (requestParameters.filterSex) {
            queryParameters['filterSex'] = requestParameters.filterSex;
        }

        if (requestParameters.filterPhone) {
            queryParameters['filterPhone'] = requestParameters.filterPhone;
        }

        if (requestParameters.filterEmail) {
            queryParameters['filterEmail'] = requestParameters.filterEmail;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:patient"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/patient`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPatientFromJSON));
    }

    /**
     * Gets a list of patients
     * Get a list of patients
     */
    async listProviderPatients(requestParameters: ListProviderPatientsRequest): Promise<Array<ProviderPatient>> {
        const response = await this.listProviderPatientsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of patients
     * Get a list of patients
     */
    async listSupportPatientsRaw(requestParameters: ListSupportPatientsRequest): Promise<runtime.ApiResponse<Array<SupportPatient>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterNickname) {
            queryParameters['filterNickname'] = requestParameters.filterNickname;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterDob) {
            queryParameters['filterDob'] = requestParameters.filterDob;
        }

        if (requestParameters.filterDod) {
            queryParameters['filterDod'] = requestParameters.filterDod;
        }

        if (requestParameters.filterSex) {
            queryParameters['filterSex'] = requestParameters.filterSex;
        }

        if (requestParameters.filterPhone) {
            queryParameters['filterPhone'] = requestParameters.filterPhone;
        }

        if (requestParameters.filterEmail) {
            queryParameters['filterEmail'] = requestParameters.filterEmail;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:patient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportPatientFromJSON));
    }

    /**
     * Gets a list of patients
     * Get a list of patients
     */
    async listSupportPatients(requestParameters: ListSupportPatientsRequest): Promise<Array<SupportPatient>> {
        const response = await this.listSupportPatientsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Patch a patient
     * Patch a patient
     */
    async patchSupportPatientRaw(requestParameters: PatchSupportPatientRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchSupportPatient.');
        }

        if (requestParameters['supportUpdatePatientPayload'] === null || requestParameters['supportUpdatePatientPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdatePatientPayload','Required parameter requestParameters.supportUpdatePatientPayload was null or undefined when calling patchSupportPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:patient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdatePatientPayloadToJSON(requestParameters['supportUpdatePatientPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Patch a patient
     * Patch a patient
     */
    async patchSupportPatient(requestParameters: PatchSupportPatientRequest): Promise<ObjectNoResponse> {
        const response = await this.patchSupportPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Debug royal CSV for collections
     * Debug royal CSV for collections
     */
    async postSupportPatientDebugRoyalCollectionsRaw(requestParameters: PostSupportPatientDebugRoyalCollectionsRequest): Promise<runtime.ApiResponse<SupportDebug>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportPatientDebugRoyalCollections.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/{id}/debug_royal_collections`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportDebugFromJSON(jsonValue));
    }

    /**
     * Debug royal CSV for collections
     * Debug royal CSV for collections
     */
    async postSupportPatientDebugRoyalCollections(requestParameters: PostSupportPatientDebugRoyalCollectionsRequest): Promise<SupportDebug> {
        const response = await this.postSupportPatientDebugRoyalCollectionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create Inbox Patient Submission
     * Create Inbox Patient Submission
     */
    async postSupportPatientInboxSubmissionRaw(requestParameters: PostSupportPatientInboxSubmissionRequest): Promise<runtime.ApiResponse<SupportInboxPatientSubmissionResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportPatientInboxSubmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/{id}/inbox_submission`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportInboxPatientSubmissionResponseFromJSON(jsonValue));
    }

    /**
     * Create Inbox Patient Submission
     * Create Inbox Patient Submission
     */
    async postSupportPatientInboxSubmission(requestParameters: PostSupportPatientInboxSubmissionRequest): Promise<SupportInboxPatientSubmissionResponse> {
        const response = await this.postSupportPatientInboxSubmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Preview royal CSV for collections
     * Preview royal CSV for collections
     */
    async postSupportPatientPreviewRoyalCollectionsRaw(requestParameters: PostSupportPatientPreviewRoyalCollectionsRequest): Promise<runtime.ApiResponse<TemporaryDocumentUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportPatientPreviewRoyalCollections.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/{id}/preview_royal_collections`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryDocumentUrlFromJSON(jsonValue));
    }

    /**
     * Preview royal CSV for collections
     * Preview royal CSV for collections
     */
    async postSupportPatientPreviewRoyalCollections(requestParameters: PostSupportPatientPreviewRoyalCollectionsRequest): Promise<TemporaryDocumentUrl> {
        const response = await this.postSupportPatientPreviewRoyalCollectionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a patient
     * Replace a patient
     */
    async replaceSupportPatientRaw(requestParameters: ReplaceSupportPatientRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplacePatientPayload'] === null || requestParameters['supportReplacePatientPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplacePatientPayload','Required parameter requestParameters.supportReplacePatientPayload was null or undefined when calling replaceSupportPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:patient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplacePatientPayloadToJSON(requestParameters['supportReplacePatientPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a patient
     * Replace a patient
     */
    async replaceSupportPatient(requestParameters: ReplaceSupportPatientRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a patient
     * Update a patient
     */
    async updateSupportPatientRaw(requestParameters: UpdateSupportPatientRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportPatient.');
        }

        if (requestParameters['supportUpdatePatientPayload'] === null || requestParameters['supportUpdatePatientPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdatePatientPayload','Required parameter requestParameters.supportUpdatePatientPayload was null or undefined when calling updateSupportPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:patient", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/patient/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdatePatientPayloadToJSON(requestParameters['supportUpdatePatientPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a patient
     * Update a patient
     */
    async updateSupportPatient(requestParameters: UpdateSupportPatientRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportPatientRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderPatientsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportPatientsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
